module.exports = __webpack_public_path__ + "img/reset_password.svg";